import { TreatmentArea } from '../types';

export const FEMALE_TREATMENT_AREAS: TreatmentArea[] = [
  {
    id: 'tum-bacak',
    name: 'Tüm Bacak (Üst & Alt Bacak)',
    category: 'lower',
    shortDesc: 'Batık, çilek bacak ve kıl dönmesine son. Geniş safir buz başlıkla pürüzsüz ve ipeksi bacaklar.',
    longDesc: 'Kadınlarda en çok tercih edilen seans alanıdır. Ağda ve epilatörün yol açtığı batıklar ve çilek görünümü -5°C safir soğutmalı buz başlık teknolojimizle yok edilir. Kökler homojen taranarak ipeksi bir pürüzsüzlük sağlanır.',
    durationMinutes: 30,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Etek, elbise ve yaz tatillerinde kusursuz ipeksi bacaklara sahip olmak isteyen kadınlar',
    benefits: [
      'Ağda ve jilet batıklarını ve çilek bacak görünümünü onarır',
      'Geniş safir başlıkla acısız, serinletici masaj konforunda seans',
      'Yaz-kış bronz tende dahi güvenli 4 dalga boylu teknoloji',
      'Kalıcı pürüzsüzlük ve sıfır tahriş'
    ],
    preparationTip: 'Seansınızdan 24 saat önce bacaklarınızı jilet yardımıyla nazikçe tıraş ediniz.',
    iconName: 'Sparkles'
  },
  {
    id: 'genital-bikini',
    name: 'Genital & Bikini Bölgesi',
    category: 'lower',
    shortDesc: '%100 kadın estetisyen eşliğinde, yüksek mahremiyet ve buz başlıkla sıfıra yakın acı.',
    longDesc: 'Hassas bölgede maksimum hijyen, tek kullanımlık steril örtüler ve deneyimli kadın estetisyenlerimizle %100 mahremiyet garantisi. Safir soğutma teknolojisi sayesinde acı hissi minimuma iner.',
    durationMinutes: 15,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 2,
    popularFor: 'Hijyen, yaz konforu ve batıklardan tamamen kurtulmak isteyen kadınlar',
    benefits: [
      'Yalnızca kadın estetisyen kontrolünde %100 mahrem seans odaları',
      '-5°C temas soğutmalı safir kristal ile acısız konfor',
      'Ağda kaynaklı kararma ve tahriş oluşumunu önler',
      'Kıl dönmesi ve sivilcelenmeyi kalıcı olarak durdurur'
    ],
    preparationTip: 'İşlemden 1 gün önce genital bölgenizi jiletle temizleyiniz, kimyasal tüy dökücü krem kullanmayınız.',
    iconName: 'Shield'
  },
  {
    id: 'koltuk-alti-kadin',
    name: 'Koltuk Altı',
    category: 'upper',
    shortDesc: 'Ter kokusu ve kararmaya karşı ferahlık. Sadece 5 dakikada acısız ve kalıcı pürüzsüzlük.',
    longDesc: 'Koltuk altı tüylerinin yok edilmesi hem hijyen sağlar hem de ağda lekelerinin açılmasına yardımcı olur. Seans süresi yalnızca 5 dakika sürer ve kıl kökleri ilk seanstan itibaren dökülmeye başlar.',
    durationMinutes: 5,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Kolsuz kıyafetlerde özgürlük, sıfır gölge ve ferah hijyen',
    benefits: [
      'Sadece 5 dakikada tamamlanan ultra hızlı uygulama',
      'Sürekli tıraş kaynaklı gri ton ve kararmaları azaltır',
      'Bakteri tutunmasını azaltarak ter kokusunu önler',
      'İlk seanstan itibaren %80 dökülme oranı'
    ],
    preparationTip: 'İşlem günü deodorant, roll-on veya parfüm uygulamadan geliniz.',
    iconName: 'Sparkles'
  },
  {
    id: 'tum-kol-yarim-kol',
    name: 'Tüm Kol & Yarım Kol',
    category: 'arms',
    shortDesc: 'İnce ve sarımsı tüyleri dahi gören gelişmiş hibrit dalga boyuyla homojen pürüzsüzlük.',
    longDesc: 'Kollardaki tüyler genellikle vücudun diğer yerlerine göre daha incedir. Kliniğimizdeki 4 dalga boylu medikal cihaz, açık renkli ve ince tüyleri de tetiklemeden kalıcı olarak döker.',
    durationMinutes: 20,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Kollarındaki tüy yoğunluğundan rahatsız olan ve homojen ten rengi isteyen kadınlar',
    benefits: [
      'İnce ve açık tonlu kol tüylerinde dahi yüksek başarı',
      'Tüyleri kalınlaştırmadan ve tetiklemeden kökten kurutma',
      'Pürüzsüz ve kadifemsi ten hissi',
      'Güneş lekesi riski oluşturmayan medikal protokol'
    ],
    preparationTip: 'İşlemden 1 gün önce kollarınızı jiletle düzeltiniz.',
    iconName: 'Flame'
  },
  {
    id: 'yuz-biyik-cene',
    name: 'Yüz, Dudak Üstü (Bıyık) & Çene',
    category: 'face',
    shortDesc: 'Hormonal tüylenmeye özel hassas dozaj. İnce uçlu başlıkla lekesiz ve pürüzsüz yüz.',
    longDesc: 'Kadınlarda yüz bölgesi ince tüy yapısı ve hormonal dalgalanmalara açıktır. Doktor denetimli kliniğimizde özel dar başlık ve cilde uygun frekansla tetikleme yapmadan güvenle seans uygulanır.',
    durationMinutes: 10,
    recommendedSessions: '8 - 10 Seans',
    painLevel: 1,
    popularFor: 'Bıyık ve çene bölgesindeki koyu tüylerden cımbız ve iple uğraşmadan kurtulmak isteyenler',
    benefits: [
      'Tüyleri sertleştirmeyen ve yaymayan patentli enerji kontrolü',
      'Leke bırakmayan ve ben koruyucu bariyerle güvenli seans',
      'Fondöten ve makyajın yüzde pürüzsüz durmasını sağlar',
      'Ciltte kızarıklık ve yanık riski oluşturmaz'
    ],
    preparationTip: 'Yüz bölgesindeki tüyleri cımbız veya iple kökten çekmeyiniz, yüz jiletiyle kısaltınız.',
    iconName: 'Sparkles'
  },
  {
    id: 'sirt-gobek-cizgisi',
    name: 'Sırt & Göbek Çizgisi',
    category: 'upper',
    shortDesc: 'Dekolte ve bikini kıyafetlerinde özgürlük. İnce tüyler için optimize edilmiş soğuk başlık.',
    longDesc: 'Göbek çizgisi ve sırt bölgesindeki dağınık tüyler kadınlarda estetik rahatsızlık yaratabilir. Buz başlıklı konforlu tarama ile tüm bölge eşit şekilde taranır.',
    durationMinutes: 15,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Mayo, bikini ve crop kıyafetleri güvenle giymek isteyen kadınlar',
    benefits: [
      'Göbek altı çizgisindeki koyu tüyleri kalıcı temizler',
      'Sırttaki ince tüylenmeyi homojen olarak döker',
      'Cilt dokusunu yenileyici kolajen uyarımı',
      'Sıfır acı ve maksimum ferahlık'
    ],
    preparationTip: 'Seans öncesi duş alarak bölgeyi jiletle nazikçe alınız.',
    iconName: 'Shield'
  },
  {
    id: 'kadin-avantaj-paketi',
    name: 'Kadın 3’lü Gold Paket (Tüm Bacak + Genital + Koltuk Altı)',
    category: 'packages',
    shortDesc: 'Bursa kadınlarının en çok tercih ettiği komple paket. %100 mahremiyet ve tek seansta tam konfor.',
    longDesc: 'Tüm bacak, genital/bikini ve koltuk altı bölgelerini kapsayan en avantajlı medikal seans protokolüdür. Tek seansta yaklaşık 45 dakikada baştan ayağa konfor ve pürüzsüzlük sunar.',
    durationMinutes: 45,
    recommendedSessions: '6 - 8 Seans',
    painLevel: 1,
    popularFor: 'Komple temizlik, maksimum fiyat avantajı ve tek seferde tüm vücut rahatlığı',
    benefits: [
      'Ayrı ayrı seanslara göre %35 daha ekonomik avantaj paketi',
      '45 dakikada tüm ana bölgelerin tek seansta bitirilmesi',
      'Kadın estetisyen eşliğinde VIP seans odası tahsisi',
      'Ücretsiz ara kontrol ve dökülme takip garantisi'
    ],
    preparationTip: 'Tüm bölgelerin 24 saat önce jiletle temizlenmiş olması yeterlidir.',
    iconName: 'Sparkles'
  }
];
